import agreementsPolicies from "./agreementsPolicies.json";
import businessProfile from "./businessProfile.json";
import warehouses from "./warehouses.json";
import storeLocations from "./storeLocations.json";
import weeklyBusinessHours from "./weeklyBusinessHours.json";
import holidaysTable from "./holidaysTable.json";
import deposits from "./deposits.json";
import donation from "./donation.json";
import notifications from "./notifications.json";
import paymentMethods from "./paymentMethods.json";
import pricingPayments from "./pricingPayments.json";
import quickBooks from "./quickBooks.json";
import returns from "./returns.json";
import taxes from "./taxes.json";
import tip from "./tip.json";
import languageSettings from "./languageSettings.json";

import userActivity from "./user/activity.json";

import usersCommon from "./users/common.json";
import addUserSchedule from "./users/addUserSchedule.json";
import addUsers from "./users/addUsers.json";
import createRole from "./users/createRole.json";
import employeeType from "./users/employeeType.json";
import manageUser from "./users/manageUser.json";
import payType from "./users/payType.json";
import searchUsers from "./users/searchUsers.json";
import tabs from "./users/tabs.json";
import userRoles from "./users/userRoles.json";
import userSchedule from "./users/userSchedule.json";

import loyaltyTabs from "./loyalty/tabs.json";
import loyaltyCreateLoyalty from "./loyalty/createLoyalty.json";
import loyaltyCommon from "./loyalty/common.json";
import loyaltyReward from "./loyalty/reward.json";
import loyaltyActivity from "./loyalty/activity.json";
import loyaltyProgramInfo from "./loyalty/programInfo.json";
import loyaltyLoyaltyBoard from "./loyalty/loyaltyBoard.json";
import loyaltyAddEditRewardForm from "./loyalty/addEditRewardForm.json";
import loyaltyAmountSpentCreate from "./loyalty/amountSpentCreate.json";
import loyaltyVisitBasedCreate from "./loyalty/visitBasedCreate.json";
import loyaltyProductBasedLoyaltyCreate from "./loyalty/productBasedLoyaltyCreate.json";
import loyaltyCategoryBasedLoyaltyCreate from "./loyalty/categoryBasedLoyaltyCreate.json";

import templatesCommon from "./templates/common.json";
import deliveryTemplates from "./templates/deliveryTemplates.json";
import invoiceTemplates from "./templates/invoiceTemplates.json";
import receiptTemplate from "./templates/receiptTemplate.json";
import salesTemplates from "./templates/salesTemplates.json";
import shipmentTemplates from "./templates/shipmentTemplates.json";

// One JSON per screen in the Setup module. The key path mirrors the file path:
// setting/notifications.json is `notifications.*`, setting/user/activity.json is
// `user.activity.*`, setting/templates/receiptTemplate.json is
// `templates.receiptTemplate.*`. Add a screen by dropping in its JSON and adding it
// here; src/i18n/index.ts stays untouched.
const setting = {
  agreementsPolicies,
  businessProfile,
  warehouses,
  storeLocations,
  weeklyBusinessHours,
  holidaysTable,
  deposits,
  donation,
  notifications,
  paymentMethods,
  pricingPayments,
  quickBooks,
  returns,
  taxes,
  tip,
  languageSettings,
  user: {
    activity: userActivity,
  },
  users: {
    common: usersCommon,
    addUserSchedule,
    addUsers,
    createRole,
    employeeType,
    manageUser,
    payType,
    searchUsers,
    tabs,
    userRoles,
    userSchedule,
  },
  loyalty: {
    tabs: loyaltyTabs,
    createLoyalty: loyaltyCreateLoyalty,
    common: loyaltyCommon,
    reward: loyaltyReward,
    activity: loyaltyActivity,
    programInfo: loyaltyProgramInfo,
    loyaltyBoard: loyaltyLoyaltyBoard,
    addEditRewardForm: loyaltyAddEditRewardForm,
    amountSpentCreate: loyaltyAmountSpentCreate,
    visitBasedCreate: loyaltyVisitBasedCreate,
    productBasedLoyaltyCreate: loyaltyProductBasedLoyaltyCreate,
    categoryBasedLoyaltyCreate: loyaltyCategoryBasedLoyaltyCreate,
  },
  templates: {
    common: templatesCommon,
    deliveryTemplates,
    invoiceTemplates,
    receiptTemplate,
    salesTemplates,
    shipmentTemplates,
  },
};

export default setting;
